import { comparisonFeatures, howItWorksSteps } from '@/mocks/seoContent';

export default function FeatureComparison() {
  return (
    <section className="relative w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6 lg:px-12">
        <div className="max-w-2xl mb-12">
          <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-3">
            Why OOPBuy Spreadsheet
          </p>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 leading-tight">
            Structured Comparison vs Traditional Shopping
          </h2>
          <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-xl">
            OOPBuy Spreadsheet is a structured product sourcing and comparison system designed to help users analyze products more efficiently using a spreadsheet-based workflow. Unlike traditional browsing methods, it organizes product data into structured formats that improve decision-making speed.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          <div className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden">
            <div className="p-5 md:p-6">
              <h3 className="text-sm font-semibold text-foreground-950 mb-4">
                Feature Comparison
              </h3>
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-background-200">
                      <th className="text-left py-3 pr-4 text-xs font-semibold text-foreground-500 uppercase tracking-wider">
                        Feature
                      </th>
                      <th className="text-left py-3 pr-4 text-xs font-semibold text-accent-700 uppercase tracking-wider">
                        OOPBuy Spreadsheet
                      </th>
                      <th className="text-left py-3 text-xs font-semibold text-foreground-400 uppercase tracking-wider">
                        Traditional Shopping
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {comparisonFeatures.map((row) => (
                      <tr key={row.feature} className="border-b border-background-200/50">
                        <td className="py-3 pr-4 text-foreground-800 font-medium">
                          {row.feature}
                        </td>
                        <td className="py-3 pr-4 text-accent-700 font-medium">
                          {row.oopbuy}
                        </td>
                        <td className="py-3 text-foreground-500">
                          {row.traditional}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950 mb-5">
              How It Works
            </h3>
            <div className="space-y-0">
              {howItWorksSteps.map((item, index) => (
                <div
                  key={item.step}
                  className="flex gap-4 py-4 border-b border-background-200/50 last:border-b-0"
                >
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                    <span className="text-sm font-bold text-accent-700">
                      {String(item.step).padStart(2, '0')}
                    </span>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-950">
                      Step {item.step}: {item.title}
                    </h4>
                    <p className="mt-1 text-xs text-foreground-600 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}